import { render } from "./gazitLocalTime.vue?vue&type=template&id=47b7dd87&scoped=true"
import script from "./gazitLocalTime.vue?vue&type=script&lang=js"
export * from "./gazitLocalTime.vue?vue&type=script&lang=js"

import "./gazitLocalTime.vue?vue&type=style&index=0&id=47b7dd87&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b7dd87"]])

export default __exports__